const communicationLang = {

}

const agregateDatas = {

}

export default {
  communication: communicationLang,
  agregateDatas
}
